import * as React from "react";

function SvgBlueCalendar(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={20.515} {...props}>
      <path
        d="M18.151 0a.837.837 0 00-.837.836V1.5H6.683V.836a.836.836 0 10-1.671 0V1.5H1.923A1.926 1.926 0 000 3.419v15.172a1.926 1.926 0 001.923 1.923h20.154A1.926 1.926 0 0024 18.591V3.419A1.93 1.93 0 0022.075 1.5h-3.088V.836A.836.836 0 0018.151 0zm0 4.689a.838.838 0 00.837-.837v-.433h3.09V6.04H1.923V3.419h3.09v.432a.837.837 0 101.673 0v-.432h10.631v.432a.837.837 0 00.836.838zM1.923 18.591V7.7h20.154v10.891zm15.1-9.259H6.98a.837.837 0 000 1.673h10.04a.837.837 0 100-1.673zm0 4.529H6.98a.837.837 0 000 1.673h10.04a.837.837 0 100-1.673z"
        fill="#039be5"
      />
    </svg>
  );
}

export default SvgBlueCalendar;
